import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["flow"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import ApplicationDefaultValuesState from "./application-default-values-state";
import { updateField } from "@joandvgv/vuex-map-fields";
import Vue from "vue";
import { getApplicationDefaultValueOnAddition, getApplicationWithDefaults, getApplicationWithDefaultsForPage } from "@Shared/@Utils/utils";
import { cloneDeep, forOwn, get, isArray, isObject, merge, set } from "lodash";
export const SET_SCHEMA = "SET_SCHEMA";
export const SET_RAW_SCHEMA = "SET_RAW_SCHEMA";
export const SET_APPLICATION = "SET_APPLICATION";
export const MARK_PAGE_AS_SUBMITTED = "MARK_PAGE_AS_SUBMITTED";
export const UPDATE_FIELD = "UPDATE_FIELD";
export const REMOVE_APPLICATION_PAGE_DATA = "REMOVE_APPLICATION_PAGE_DATA";
export const INSERT_APPLICATION_GROUP_ITEM = "INSERT_APPLICATION_GROUP_ITEM";
export const SET_APPLICATION_GROUP_ITEM = "SET_APPLICATION_GROUP_ITEM";
export const REMOVE_APPLICATION_GROUP_ITEM = "REMOVE_APPLICATION_GROUP_ITEM";
export const MARK_APPLICATION_AS_SUBMITTED = "MARK_APPLICATION_AS_SUBMITTED";
export const SET_DISCLAIMERS = "SET_DISCLAIMERS";
export const SET_APPLICATION_DETAILS = "SET_APPLICATION_DETAILS";
export const SET_EMPTY_APPLICATION = "SET_EMPTY_APPLICATION";
export const SET_LOADED_IN_LOCAL = "SET_LOADED_IN_LOCAL";
export const SET_APPLICATION_VALIDATIONS = "SET_APPLICATION_VALIDATIONS";
export const MARK_APPLICATION_GROUP_VISIBILITY = "MARK_APPLICATION_GROUP_VISIBILITY";
export const SET_APPLICATIONS = "SET_APPLICATIONS";
export const SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE = "SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE";
export const SET_CONSOLIDATED_REQUEST = "SET_CONSOLIDATED_REQUEST";
export const SET_RAW_APPLICATION = "SET_RAW_APPLICATION";
export const SET_APPLICATION_VUELIDATIONS = "SET_APPLICATION_VUELIDATIONS";
const fillArrays = (emptyApplication, application) => {
  return function fill(currentEmptyObj, currentAppObj) {
    forOwn(currentEmptyObj, (value, key) => {
      if (isObject(value) && currentAppObj && currentAppObj[key]) {
        fill(value, currentAppObj[key]);
      }
      if (isArray(value) && currentAppObj[key] && value.length < currentAppObj[key].length) {
        var _context;
        currentEmptyObj[key] = _mapInstanceProperty(_context = currentAppObj[key]).call(_context, () => cloneDeep(value[0]));
      }
    });
    return currentEmptyObj;
  }(cloneDeep(emptyApplication), application);
};
export default {
  updateField,
  [SET_SCHEMA]: (state, data) => {
    state.schema = data;
  },
  [SET_RAW_SCHEMA]: (state, {
    schema,
    fillOutSections,
    isConsolidatedRequest
  }) => {
    let flowsObject = {};
    if (isConsolidatedRequest) {
      var _context2, _context3;
      const nonFlowKeys = ["customizationId", "metadata", "translationMap", "showDirectToLender"];
      const flowsKeys = _filterInstanceProperty(_context2 = _Object$keys(schema)).call(_context2, key => !_includesInstanceProperty(nonFlowKeys).call(nonFlowKeys, key));
      const flows = _filterInstanceProperty(_context3 = _mapInstanceProperty(flowsKeys).call(flowsKeys, flow => schema[flow])).call(_context3, flow => Array.isArray(flow));
      const filteredFlows = _mapInstanceProperty(flows).call(flows, flow => _filterInstanceProperty(flow).call(flow, ({
        key
      }) => _includesInstanceProperty(fillOutSections).call(fillOutSections, key)));
      filteredFlows.forEach((value, index) => {
        flowsObject[flowsKeys[index]] = value;
      });
    }
    state.rawSchema = _objectSpread(_objectSpread({}, schema), flowsObject);
  },
  [SET_EMPTY_APPLICATION]: (state, {
    flow,
    emptyApplication
  }) => {
    state.emptyApplication[flow] = emptyApplication;
  },
  [SET_DISCLAIMERS]: (state, {
    disclaimers
  }) => {
    state.disclaimers = disclaimers;
  },
  [SET_RAW_APPLICATION]: (state, application) => {
    Vue.set(state, "rawApplication", application);
  },
  [SET_APPLICATION]: (state, _ref) => {
    let {
        flow
      } = _ref,
      data = _objectWithoutProperties(_ref, _excluded);
    const emptyToUse = fillArrays(state.emptyApplication[flow], _objectSpread(_objectSpread({}, cloneDeep(data)), {}, {
      flow
    }));
    state.emptyApplication[flow] = cloneDeep(emptyToUse);
    const filledApplication = merge(emptyToUse, _objectSpread(_objectSpread({}, data), {}, {
      flow
    }));
    state.application = getApplicationWithDefaults(filledApplication, ApplicationDefaultValuesState);
    state.rawApplication = {};
  },
  [SET_LOADED_IN_LOCAL]: state => {
    state.loadedInLocal = true;
  },
  [MARK_PAGE_AS_SUBMITTED]: (state, {
    page,
    submitted = true
  }) => {
    const isArray = Array.isArray(state.application[page]);
    if (isArray) {
      state.application[page].forEach((item, idx) => {
        state.application[page][idx] = _objectSpread(_objectSpread({}, state.application[page][idx]), {}, {
          submittedFromClient: submitted
        });
      });
    } else {
      state.application[page] = _objectSpread(_objectSpread({}, state.application[page]), {}, {
        submittedFromClient: submitted
      });
    }
  },
  [UPDATE_FIELD]: (state, {
    path,
    key,
    value
  }) => {
    get(state.application, path)[key] = value;
  },
  [MARK_APPLICATION_AS_SUBMITTED]: (state, {
    isConsolidatedRequest = false,
    applicationId
  } = {}) => {
    if (isConsolidatedRequest) {
      state.consolidatedRequest.metadata.status = "submitted";
    } else {
      var _state$applications, _state$applications$b;
      state.application.applicationStatus = "submitted";
      state.applicationDetails.applicationStatus = "submitted";
      if ((_state$applications = state.applications) != null && (_state$applications$b = _state$applications.byId) != null && _state$applications$b[applicationId]) {
        state.applications.byId[applicationId].applicationStatus = "submitted";
      }
    }
  },
  [SET_APPLICATION_GROUP_ITEM]: (state, {
    what,
    where
  }) => {
    const applicationObject = cloneDeep(state.application);
    set(applicationObject, where, [what]);
    const applicationObjectWithDefaults = getApplicationDefaultValueOnAddition({
      what,
      where
    }, applicationObject, ApplicationDefaultValuesState);
    Vue.set(state, "application", applicationObjectWithDefaults);
  },
  [INSERT_APPLICATION_GROUP_ITEM]: (state, {
    what,
    where
  }) => {
    const applicationObject = cloneDeep(state.application);
    const applicationItem = get(applicationObject, where);
    applicationItem.push(what);
    const applicationObjectWithDefaults = getApplicationDefaultValueOnAddition({
      what,
      where
    }, applicationObject, ApplicationDefaultValuesState);
    Vue.set(state, "application", applicationObjectWithDefaults);
    const flow = state.application.flow;
    const emptyToUse = fillArrays(state.emptyApplication[flow], _objectSpread(_objectSpread({}, cloneDeep(state.application)), {}, {
      flow
    }));
    state.emptyApplication[flow] = cloneDeep(emptyToUse);
  },
  [SET_APPLICATION_WITH_DEFAULTS_FOR_PAGE]: (state, {
    page
  }) => {
    const applicationObject = cloneDeep(state.application);
    const applicationObjectWithDefaults = getApplicationWithDefaultsForPage(page, applicationObject, ApplicationDefaultValuesState);
    Vue.set(state, "application", applicationObjectWithDefaults);
  },
  [REMOVE_APPLICATION_GROUP_ITEM]: (state, {
    index,
    where,
    startEmpty
  }) => {
    const currentApplicationGroup = get(state.application, where);
    const emptyApplication = cloneDeep(state.emptyApplication[state.application.flow]);
    const currentFirstOneVisible = currentApplicationGroup[0].groupSetVisible;
    if (index === 0 && currentApplicationGroup[1]) {
      currentApplicationGroup[1].groupSetVisible = currentFirstOneVisible;
    }
    if (currentApplicationGroup.length === 1 && startEmpty) {
      const whereDefault = where.replace(/\[[1-9]\d*\]/, "[0]");
      const defaultApplicationGroup = get(emptyApplication, whereDefault)[0];
      defaultApplicationGroup.groupSetVisible = false;
      return Vue.set(get(state.application, where), 0, defaultApplicationGroup);
    }
    _spliceInstanceProperty(currentApplicationGroup).call(currentApplicationGroup, index, 1);
  },
  [REMOVE_APPLICATION_PAGE_DATA]: (state, {
    page
  }) => {
    state.application = _objectSpread(_objectSpread({}, state.application), {}, {
      [page]: page === "co-applicants" ? [{
        "personal-details": {}
      }] : {}
    });
  },
  [SET_APPLICATION_DETAILS]: (state, applicationDetails) => {
    state.applicationDetails = _objectSpread(_objectSpread({}, state.applicationDetails), applicationDetails);
  },
  [MARK_APPLICATION_GROUP_VISIBILITY]: ({
    application
  }, {
    where,
    visibility
  }) => {
    Vue.set(get(application, where)[0], "groupSetVisible", visibility);
  },
  [SET_APPLICATION_VALIDATIONS]: (state, {
    errors
  }) => {
    state.applicationValidations = errors;
  },
  [SET_APPLICATIONS]: (state, {
    applications
  }) => {
    state.applications.byId = applications.byId;
    state.applications.allIds = applications.allIds;
  },
  [SET_CONSOLIDATED_REQUEST]: (state, {
    consolidatedRequest
  }) => {
    Vue.set(state, "consolidatedRequest", consolidatedRequest);
  },
  [SET_APPLICATION_VUELIDATIONS]: (state, {
    validations
  }) => {
    Vue.set(state, "applicationVuelidations", validations);
  }
};